import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getMeasure } from '../performance';
import { resolvedEvent, unresolvedEvent } from './analytics';
export { ANALYTICS_CHANNEL, context, fireSmartLinkEvent, resolvedEvent, unresolvedEvent, invokeSucceededEvent, invokeFailedEvent, chunkloadFailedEvent, connectSucceededEvent, connectFailedEvent, trackAppAccountAuthStarted, trackAppAccountConnected, uiAuthEvent, uiAuthAlternateAccountEvent, uiCardClickedEvent, uiActionClickedEvent, uiClosedAuthEvent, screenAuthPopupEvent, uiRenderSuccessEvent, uiRenderFailedEvent, uiHoverCardViewedEvent, uiHoverCardDismissedEvent, uiHoverCardOpenLinkClickedEvent, uiLearnMoreLinkClickedEvent, uiIframeDwelledEvent, uiSmartLinkStatusLozengeButtonClicked, uiSmartLinkStatusListItemButtonClicked, uiSmartLinkStatusOpenPreviewButtonClicked } from './analytics';
export var instrumentEvent = function instrumentEvent(_ref) {
  var id = _ref.id,
    status = _ref.status,
    extensionKey = _ref.extensionKey,
    definitionId = _ref.definitionId,
    resourceType = _ref.resourceType,
    destinationProduct = _ref.destinationProduct,
    destinationSubproduct = _ref.destinationSubproduct,
    location = _ref.location,
    error = _ref.error;
  var measure = getMeasure(id, status) || {
    duration: undefined
  };
  if (status === 'resolved') {
    var event = resolvedEvent({
      id: id,
      extensionKey: extensionKey,
      definitionId: definitionId,
      resourceType: resourceType,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location
    });
    return _objectSpread(_objectSpread({}, event), {}, {
      attributes: _objectSpread(_objectSpread({}, event.attributes), {}, {
        duration: measure.duration
      })
    });
  } else {
    if ((error === null || error === void 0 ? void 0 : error.type) !== 'ResolveUnsupportedError') {
      var _event = unresolvedEvent({
        id: id,
        status: status,
        extensionKey: extensionKey,
        definitionId: definitionId,
        resourceType: resourceType,
        destinationProduct: destinationProduct,
        destinationSubproduct: destinationSubproduct,
        location: location,
        error: error
      });
      return _objectSpread(_objectSpread({}, _event), {}, {
        attributes: _objectSpread(_objectSpread({}, _event.attributes), {}, {
          duration: measure.duration
        })
      });
    }
  }
};